<template>
  <div class="container">
    <p class="label" v-html="label" />
    <p class="description" v-if="description" v-html="description" />
    <p class="detail" v-html="detail" />
  </div>
</template>

<script>
export default {
  name: "OfferElement",
  props: {
    label: String,
    description: String,
    detail: String,
    labelLight: Boolean
  }
};
</script>

<style scoped></style>
